import { useState } from 'react'
import { X, Share, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'

const isIOS = () =>
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !('MSStream' in window)

const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  ('standalone' in navigator && (navigator as unknown as { standalone: boolean }).standalone)

const DISMISSED_KEY = 'brainhub-install-banner-dismissed'

const shouldShowBanner = () => {
  if (!isIOS() || isStandalone()) return false
  try {
    if (localStorage.getItem(DISMISSED_KEY)) return false
  } catch { /* localStorage unavailable in private mode */ }
  return true
}

export function InstallBanner() {
  const [show, setShow] = useState(shouldShowBanner)

  const dismiss = () => {
    setShow(false)
    try {
      localStorage.setItem(DISMISSED_KEY, Date.now().toString())
    } catch { /* localStorage unavailable in private mode */ }
  }

  if (!show) return null

  return (
    <div className="fixed bottom-20 inset-x-4 z-50 md:hidden">
      <div className="bg-card border rounded-xl shadow-lg p-4 flex items-start gap-3">
        <div className="shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <img src="/icons/icon-192.png" alt="Menta" className="w-8 h-8 rounded" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm">Instalar Menta</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Toca <Share className="inline h-3 w-3" /> y luego{' '}
            <span className="font-medium">"Agregar a inicio"</span>{' '}
            <Plus className="inline h-3 w-3" />
          </p>
        </div>
        <Button variant="ghost" size="icon" className="shrink-0 h-8 w-8" onClick={dismiss}>
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
